import React from 'react';

import { Box, Typography } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';

import SimpleFormLayout from 'components/SimpleFormLayout';
import MUTATION_KEYS from 'config/api/MUTATION_KEYS';
import organizationsApi from 'config/api/organizations/organizations';
import auth_messages from 'messages/auth_messages';
import general_messages from 'messages/general_messages';
import PATHS from 'router/PATHS';

const RegisterEmailSent = () => {
  const { t } = useTranslation();
  const { state: data } = useLocation() as { state: { email: string } };
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  if (!data) {
    history.push({
      pathname: PATHS.AUTH,
    });
  }

  const resendLinkMutation = useMutation(MUTATION_KEYS.RESEND_ORGANIZATION_ACTIVATION_LINK, organizationsApi.resendActivationLink, {
    onSuccess: () => {
      enqueueSnackbar(t(auth_messages.activation_email_notification), {
        variant: 'success',
      });
    },
    onError: () => {
      enqueueSnackbar(t(general_messages.something_went_wrong), { variant: 'error' });
    },
  });

  const onSubmit = async (e: SubmitEvent) => {
    e.preventDefault();
    resendLinkMutation.mutate({ email: data.email });
  };

  return (
    <SimpleFormLayout
      buttonVariant='outlined'
      onSubmit={onSubmit}
      sending={resendLinkMutation.isLoading}
      submitLabel={t(auth_messages.resend_activation_email)}
      title={t(auth_messages.reset_password_sent)}
    >
      <Typography component='h3' variant='h3'>
        {t(auth_messages.check_email)}
      </Typography>
      <Box pt={1}>
        <Typography variant='body1'>{t(auth_messages.activation_link)}</Typography>
      </Box>
    </SimpleFormLayout>
  );
};

export default RegisterEmailSent;
